import { render, staticRenderFns } from "./ChartClientesWindRose.vue?vue&type=template&id=1efb2157&scoped=true&"
import script from "./ChartClientesWindRose.vue?vue&type=script&lang=js&"
export * from "./ChartClientesWindRose.vue?vue&type=script&lang=js&"
import style0 from "./ChartClientesWindRose.vue?vue&type=style&index=0&id=1efb2157&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efb2157",
  null
  
)

export default component.exports